import type { ReferencesContextValue } from "./ReferencesContextValue"

export const defaultReferencesContextValue: ReferencesContextValue = {
  listElementRef: { current: null },
  listHeaderRef: { current: null },
  listItemHeaderRef: { current: null },
}
